import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    Heading,
    Box,
    HStack,
    Icon
} from "@chakra-ui/react";
import { FaAward } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const memberBio = {
    aren: {
        hy: {
            status: "ՀՀ Փաստաբանների պալատի անդամ, փաստաբան (արտոնագիր)",
            eduTitle: "Կրթություն և Գործունեություն․",
            timeline: [
                "2016–2022թթ․ — ԵՊՀ Իրավագիտության ֆակուլտետ",
                "2021–2023թթ․ — «Վիրտուլեքս» ՍՊԸ՝ որպես իրավաբան",
                "2022–2023թթ․ — ՀՀ Փաստաբանական ակադեմիա",
                "2023–2024թթ․ — «Ասպեկտուս» ՍՊԸ՝ որպես իրավաբան",
                "2023թ․-ից — «Երևան բժշկագիտական կենտրոն» ՓԲԸ՝ որպես իրավաբան",
                "2024թ․-ից — «Լեգալ Տիտան» ՍՊԸ համահիմնադիր-փաստաբան"
            ],
            specTitle: "Մասնագիտացում․",
            specializations: [
                "Քաղաքացիական իրավունք",
                "Կորպորատիվ իրավունք",
                "Պայմանագրային իրավունք",
                "Վարչական իրավունք",
                "Սնանկություն",
                "Գնումների հետ կապված վեճեր"
            ],
            note: "Փաստաբան է և հանդիսանում է ՀՀ Փաստաբանների պալատի անդամ։"
        },
        en: {
            status: "Member of the Chamber of Advocates of RA, Licensed Attorney",
            eduTitle: "Education & Professional Background:",
            timeline: [
                "2016–2022 — Yerevan State University, Faculty of Law",
                "2021–2023 — 'Virtulex' LLC, Legal Counsel",
                "2022–2023 — Academy of Advocates of the Republic of Armenia",
                "2023–2024 — 'Aspectus' LLC, Legal Counsel",
                "2023–present — 'Yerevan Medical Scientific Center' CJSC, Legal Counsel",
                "2024–present — 'Legal Titan' LLC, Co-founder & Attorney-at-Law"
            ],
            specTitle: "Areas of Specialization:",
            specializations: [
                "Civil Law",
                "Corporate Law",
                "Contract Law",
                "Administrative Law",
                "Bankruptcy & Insolvency",
                "Public & Private Procurement Disputes"
            ],
            note: "Licensed Attorney and Member of the Chamber of Advocates of the Republic of Armenia."
        },
        ru: {
            status: "Член Палаты адвокатов РА, лицензированный адвокат",
            eduTitle: "Образование и деятельность:",
            timeline: [
                "2016–2022 гг. — Юридический факультет Ереванского государственного университета",
                "2021–2023 гг. — ООО «Виртулекс», юрист",
                "2022–2023 гг. — Академия адвокатуры Республики Армения",
                "2023–2024 гг. — ООО «Аспектус», юрист",
                "с 2023 г. — ЗАО «Ереванский медицинский научный центр», юрист",
                "с 2024 г. — ООО «Легал Титан», соучредитель и адвокат"
            ],
            specTitle: "Специализация:",
            specializations: [
                "Гражданское право",
                "Корпоративное право",
                "Договорное право",
                "Административное право",
                "Банкротство",
                "Споры по закупкам"
            ],
            note: "Адвокат, член Палаты адвокатов Республики Армения."
        }
    },
    ashot: {
        hy: {
            status: "ՀՀ Փաստաբանների պալատի անդամ, փաստաբան (արտոնագիր)",
            eduTitle: "Կրթություն և Գործունեություն․",
            timeline: [
                "2016–2022թթ․ — Երևանի պետական համալսարանի իրավագիտության ֆակուլտետ",
                "2022–2023թթ․ — ՀՀ Փաստաբանական ակադեմիա",
                "2022–2023թթ․ — «Վիտուլեքս» ՍՊԸ՝ որպես իրավաբան",
                "2023–2024թթ․ — «Ասպեկտուս» ՍՊԸ՝ որպես իրավաբան",
                "2024թ․-ից — «Լեգալ Տիտան» ՍՊԸ համահիմնադիր-տնօրեն"
            ],
            specTitle: "Մասնագիտացում․",
            specializations: [
                "Վարչական իրավունք",
                "Քաղաքացիական իրավունք",
                "Մտավոր սեփականության իրավունք",
                "Աշխատանքային իրավունք",
                "Ֆինանսական իրավունք",
                "Ապահովագրական հարաբերություններ"
            ],
            note: "Փաստաբան է և հանդիսանում է ՀՀ Փաստաբանների պալատի անդամ։"
        },
        en: {
            status: "Member of the Chamber of Advocates of RA, Licensed Attorney",
            eduTitle: "Education & Professional Background:",
            timeline: [
                "2016–2022 — Yerevan State University, Faculty of Law",
                "2022–2023 — Academy of Advocates of the Republic of Armenia",
                "2022–2023 — 'Virtulex' LLC, Legal Counsel",
                "2023–2024 — 'Aspectus' LLC, Legal Counsel",
                "2024–present — 'Legal Titan' LLC, Co-founder & Managing Director"
            ],
            specTitle: "Areas of Specialization:",
            specializations: [
                "Administrative Law",
                "Civil Law",
                "Intellectual Property Law",
                "Labor & Employment Law",
                "Financial Law",
                "Insurance Relations"
            ],
            note: "Licensed Attorney and Member of the Chamber of Advocates of the Republic of Armenia."
        },
        ru: {
            status: "Член Палаты адвокатов РА, лицензированный адвокат",
            eduTitle: "Образование и деятельность:",
            timeline: [
                "2016–2022 гг. — Юридический факультет Ереванского государственного университета",
                "2022–2023 гг. — Академия адвокатуры Республики Армения",
                "2022–2023 гг. — ООО «Витулекс», юрист",
                "2023–2024 гг. — ООО «Аспектус», юрист",
                "с 2024 г. — ООО «Легал Титан», соучредитель и генеральный директор"
            ],
            specTitle: "Специализация:",
            specializations: [
                "Административное право",
                "Гражданское право",
                "Право интеллектуальной собственности",
                "Трудовое право",
                "Финансовое право",
                "Страховые правоотношения"
            ],
            note: "Адвокат, член Палаты адвокатов Республики Армения."
        }
    }
};

const ExperienceModal = ({ isOpen, onClose, member }) => {
    const { currentLanguage, t } = useLanguage();
    if (!member) return null;

    const key = member.memberKey || (member.name.includes("Արեն") || member.name.includes("Aren") || member.name.includes("Арен") ? "aren" : "ashot");
    const data = memberBio[key]?.[currentLanguage] || memberBio[key]?.["hy"];

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg" motionPreset="slideInBottom">
            <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(8px)" />
            <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="2xl">
                <ModalHeader
                    bg="#0b132b"
                    color="white"
                    py={6}
                    px={8}
                    borderBottom="1px solid rgba(223, 186, 115, 0.2)"
                >
                    <HStack spacing={3}>
                        <Box>
                            <Heading as="h3" fontSize="xl" fontWeight="800">
                                {member.name}
                            </Heading>
                            <Text fontSize="xs" color="#dfba73" fontWeight="600" mt={0.5}>
                                {member.role} • {member.experience}
                            </Text>
                        </Box>
                    </HStack>
                    <ModalCloseButton color="gray.300" top={6} right={6} />
                </ModalHeader>

                <ModalBody p={8} bg="white">
                    {data ? (
                        <Box fontSize="sm" color="gray.700" lineHeight="1.8">
                            <Box mb={4} p={3} borderRadius="xl" bg="brand.50" border="1px solid" borderColor="brand.100">
                                <HStack spacing={2} color="brand.700" fontWeight="700" mb={1}>
                                    <Icon as={FaAward} />
                                    <Text fontSize="xs" textTransform="uppercase">{currentLanguage === "ru" ? "Статус" : currentLanguage === "en" ? "Status" : "Կարգավիճակ"}</Text>
                                </HStack>
                                <Text fontWeight="600" color="gray.800">
                                    {data.status}
                                </Text>
                            </Box>

                            <Text fontWeight="800" color="gray.900" mb={2}>{data.eduTitle}</Text>
                            <Box pl={3} mb={4} borderLeft="2px solid" borderColor="brand.400">
                                {data.timeline.map((item, idx) => (
                                    <Text key={idx}>{item}</Text>
                                ))}
                            </Box>

                            <Text fontWeight="800" color="gray.900" mb={2}>{data.specTitle}</Text>
                            <Box pl={4}>
                                {data.specializations.map((item, idx) => (
                                    <Text key={idx}>• {item}</Text>
                                ))}
                            </Box>
                        </Box>
                    ) : (
                        <Text>Մանրամասն տեղեկություն։</Text>
                    )}
                </ModalBody>

                <ModalFooter bg="#f8fafc" borderTop="1px solid" borderColor="gray.100" p={5}>
                    <Button
                        bg="#0b132b"
                        color="#dfba73"
                        _hover={{ bg: "#162044" }}
                        onClick={onClose}
                    >
                        {t("modal.close")}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ExperienceModal;